import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LeaveTypeModel } from '../model/leave-type.model';
import { LeaveTypeService } from '../leave-type.service';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-leave-type-edit',
  templateUrl: './leave-type-edit.component.html',
  styleUrls: ['./leave-type-edit.component.scss'],
  standalone: false
})
export class LeaveTypeEditComponent implements DirtyCheck {
  title: string = "New Leave Type";
  editForm: FormGroup;
  leaveTypeInfo: LeaveTypeModel = {};
  isFormDirty: boolean = false;
  permission: any;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private leaveTypeService: LeaveTypeService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService
  ) {
    let id = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: [this.leaveTypeInfo.code, [Validators.required, Validators.maxLength(50)]],
      name: [this.leaveTypeInfo.name, [Validators.required, Validators.maxLength(100)]],
      description: [this.leaveTypeInfo.description],
      is_active: [this.leaveTypeInfo.is_active !== undefined ? (Number(this.leaveTypeInfo.is_active) === 1) : true]
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (id !== null && parseInt(id) !== 0) {
      this.setLeaveTypeInfo(id);
    }
    this.permission = this.permissionService.getRowPermission(this.permissionService.getPagePermission("leave-type"), id);
  }

  isDirty(): boolean {
    return this.isFormDirty;
  }

  navBack(): void {
    this.router.navigate(['/system/leave-type']);
  }

  setLeaveTypeInfo(id: any): void {
    this.leaveTypeService.getLeaveTypeById(id).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.leaveTypeInfo = response.data.leave_type;
          this.editForm.patchValue({
            ...this.leaveTypeInfo,
            is_active: Number(this.leaveTypeInfo.is_active) === 1
          });
          this.title = this.getTitle();
          this.isFormDirty = false;
        } else {
          this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
        }
      }
    });
  }

  getTitle(): string {
    return (!this.leaveTypeInfo.id || this.leaveTypeInfo.id == 0) ? "New Leave Type" : "Editing : " + this.leaveTypeInfo.name;
  }

  save(): void {
    if (this.editForm.valid) {
      Object.assign(this.leaveTypeInfo, this.editForm.value);
      this.leaveTypeInfo.is_active = this.editForm.get('is_active')?.value ? 1 : 0;

      this.leaveTypeService.update(this.leaveTypeInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            this.isFormDirty = false;
            this.snackBarService.openSnackBar({
              type: 'success',
              title: 'Saved',
              message: `Record for ${this.leaveTypeInfo.name} has been updated successfully.`
            });
            this.router.navigate(['/system/leave-type']);
          } else {
            this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
          }
        },
        error: (error) => {
          this.snackBarService.openSnackBar({ message: 'Connection to the server failed', title: 'Failed!!!', type: 'error' });
        }
      });
    } else {
      this.editForm.markAllAsTouched();
    }
  }
}
